import React from 'react';

const ReportsPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-h2 text-ui-text">Reports</h1>
    </div>
  );
};

export default ReportsPage;
